import {useDispatch, useSelector} from "react-redux";
import {useEffect, useState} from "react";
import Button from "../../../../components/UI/Button";
import Card from "../../../../components/UI/Card";
import {setOrderForm} from "../../../../store/slices/orderSlice";
import {useParams} from "react-router-dom";
import Input from "../../../../components/UI/form/Input";
import Select from "../../../../components/UI/form/Select";
import Modal from "../../../../components/UI/Modal";
import SearchCustomer from "./SearchCustomer";
import {getErrorObj, getValidationMessage} from "../../../../util/validationMessage";

const CustomerInfoComponent = ({setValue, register, errors, order}) =>{
  const {orderForm} = useSelector(state => state.orders)
  const [customer, setCustomer] = useState(null)

  const params = useParams()
  useEffect(()=>{
    if(orderForm.customer) {
      setCustomer(orderForm.customer)
    }
  }, [orderForm])
  const dispatch = useDispatch();
  useEffect(()=>{
    if(customer) {
      setValue('customer_id', customer.id)
      if(customer.address){
        let defaultAddress = customer.address.find(address => address.is_default_delivery_address === true)
        if(!defaultAddress){
          defaultAddress = customer.address[0]
        }
        if(defaultAddress){
          dispatch(setOrderForm({...orderForm,
            shipping_address_id: defaultAddress.id,
            shipping_name: defaultAddress.name,
            shipping_address: defaultAddress.address,
            shipping_mobile: defaultAddress.phone,
            shipping_city: defaultAddress.city,
            shipping_postal_code: defaultAddress.postal_code,
            shipping_country: defaultAddress.country,
          }))
        }
      }
    }
  }, [customer])

  const [openModal, setOpenModal] = useState(false)


  return(
      <>
        <Card>
          <h1 className="common_sub_title d_flex_btwn mt_0 mb_5">
            <span> Customer Information</span>
            {(!params.id) &&
                <span onClick={()=> setOpenModal(!openModal)} className="cursor_pointer fw_regular font_15p d_flex_center text_underline">Change Customer </span>
            }
          </h1>
          {getErrorObj(errors, 'customer_id') && <small className={'color_danger'}>{getValidationMessage(getErrorObj(errors, 'customer_id'), 'customer_id')}</small>}
          {customer ?
            <div className="checkout_summery ">
              <table className="table border_none">
                <tbody>
                <tr>
                  <td className="text_left width_100p fw_600">Name</td>
                  <td>{customer.name}</td>
                </tr>
                <tr>
                  <td className="text_left fw_600">Email</td>
                  <td>{customer.email}</td>
                </tr>
                <tr>
                  <td className="text_left fw_600">Phone</td>
                  <td>{customer.phone ? customer.phone : order?.shipping_mobile}</td>
                </tr>

                </tbody>
              </table>
            </div>
            : <div className="checkout_summery ">
              <p>Name: {order?.shipping_name}</p>
              {order?.shipping_mobile && <p>Phone: {order?.shipping_mobile}</p>}
              {order?.shipping_email && <p>Email: {order?.shipping_email}</p>}

              <span className={'color_warning'}>Guest Checkout</span>

            </div>
          }
        </Card>
        <SearchCustomer open={openModal} setOpen={setOpenModal} />

      </>
  );
}

export default CustomerInfoComponent